import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import "@/App.css";
import { SettingsProvider } from "@/lib/SettingsContext";
import { Layout } from "@/components/Layout";
import HomePage from "@/pages/HomePage";
import ServiziPage from "@/pages/ServiziPage";
import PrezziPage from "@/pages/PrezziPage";
import AmministrazioniPage from "@/pages/AmministrazioniPage";
import ContattiPage from "@/pages/ContattiPage";
import PrivacyPage from "@/pages/PrivacyPage";
import NoteLegaliPage from "@/pages/NoteLegaliPage";
import AdminLogin from "@/admin/AdminLogin";
import AdminLayout from "@/admin/AdminLayout";
import AdminDashboard from "@/admin/AdminDashboard";
import AdminLeads from "@/admin/AdminLeads";
import AdminPortfolio from "@/admin/AdminPortfolio";
import AdminSettings from "@/admin/AdminSettings";

function App() {
  return (
    <HelmetProvider>
      <SettingsProvider>
        <BrowserRouter>
          <Toaster position="top-center" richColors toastOptions={{ style: { borderRadius: 0 } }} />
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/servizi" element={<ServiziPage />} />
              <Route path="/prezzi" element={<PrezziPage />} />
              <Route path="/amministrazioni" element={<AmministrazioniPage />} />
              <Route path="/contatti" element={<ContattiPage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/note-legali" element={<NoteLegaliPage />} />
              <Route path="/ristrutturazione-bagno" element={<Navigate to="/servizi" replace />} />
              <Route path="/metodo" element={<Navigate to="/servizi" replace />} />
              <Route path="/materiali" element={<Navigate to="/servizi" replace />} />
              <Route path="/realizzazioni" element={<Navigate to="/" replace />} />
              <Route path="/realizzazioni/:id" element={<Navigate to="/" replace />} />
              <Route path="/chi-siamo" element={<Navigate to="/" replace />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route path="dashboard" element={<AdminDashboard />} />
              <Route path="richieste" element={<AdminLeads />} />
              <Route path="portfolio" element={<AdminPortfolio />} />
              <Route path="impostazioni" element={<AdminSettings />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </SettingsProvider>
    </HelmetProvider>
  );
}

export default App;
